__turbopack_context__.v({
  "content": "ZDSVca_content",
  "icon": "ZDSVca_icon",
  "panel": "ZDSVca_panel",
});
